<template>
	<div class="full-width pa-4">
		<h5 class="headline mb-5">{{ title }}</h5>
		<v-form ref="form">
			<v-layout>
				<v-flex xs12 sm12 md12 lg12>
					<v-text-field
						label="Phone Number"
						v-model="phoneNo"
						:rules="[validPhoneNoRule]"
						:validate-on-blur="true"
						placeholder="Enter Phone Number"
						class="text-field-wrapper white pt-4"
						prefix="+91"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout column align-center class="ma-4">
				<v-flex>
					<v-btn
						:disabled="phoneNo.length !== 10"
						color="primary"
						@click="markUser(true)"
					>
						Mark User As Active
					</v-btn>
				</v-flex>
				<v-flex>
					<v-btn
						:disabled="phoneNo.length !== 10"
						color="error"
						@click="markUser(false)"
					>
						Mark User As Inactive
					</v-btn>
				</v-flex>
			</v-layout>
		</v-form>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { SHOW_ALERT } from "@/store/action-types";
import { BASE_URL } from "../../../config";
import ApiService from "@/store/api-service";
import { _validPhoneNoRule } from "@/utils";

export default {
	name: "ActiveInactiveUser",
	props: ["title", "themeInputColor"],
	data() {
		return {
			phoneNo: "",
			validPhoneNoRule: _validPhoneNoRule
		};
	},
	computed: {
		...mapState({
			ACCESS_TOKEN: state => state.auth.ACCESS_TOKEN,
			alert: state => state.common.alert
		})
	},
	methods: {
		async markUser(active) {
			const payload = {
				access_token: this.ACCESS_TOKEN,
				params: {
					phoneNo: "91" + this.phoneNo,
					active
				}
			};
			try {
				const endpoint = `${BASE_URL}/jeet11-retail/v1.0.0/markRetailerByPhone`;
				const response = await ApiService.post(endpoint, payload);
				if ("errMsg" in response) {
					this.showAlert(response.errMsg);
				} else {
					const { status, errMsg } = response.response;
					if (status.toLowerCase() === "success") {
						this.showAlert(
							`Marked User as ${
								active ? "Active" : "Inactive"
							} Successfully`
						);
					} else {
						this.showAlert(errMsg);
					}
				}
			} catch (e) {
				this.showAlert(e.message);
			}
		},
		showAlert(message) {
			this.$store.dispatch(SHOW_ALERT.dispatch, {
				text: message
			});
		}
	}
};
</script>
